import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { FeeRewards } from "@/domains/minimal-pool/components/rewards/fee-rewards"
import { RewardsPagesComplexBreadcrumbApplication } from "@/domains/navigation/components/complex-breadcrumb-applications/rewards-pages-complex-breadcrumb-application"
import { RewardsLockSubItem } from "@/domains/navigation/subitems/rewards-lock-subitem"

const BREADCRUMB_ITEMS = [new RewardsLockSubItem(), RewardsPagesComplexBreadcrumbApplication]

const FeeRewardsPage = () => {
  const title = "Claim Earned Fees"
  return (
    <PageContainer>
      <MetaData title={title} />
      <PageTitle title={title} items={BREADCRUMB_ITEMS} />
      <FeeRewards />
    </PageContainer>
  )
}

export default FeeRewardsPage
